module.exports = __webpack_public_path__ + "static/img/SAMUEL-VAN-ROOYEN.1209d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAMUEL-VAN-ROOYEN.jpg
// module id = 0Jja
// module chunks = 0